// import React, {
//   useState,
//   useLayoutEffect,
//   useRef,
//   useEffect,
//   useCallback,
// } from "react";
// import debounce from "lodash/debounce";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../contexts/AuthContext";
// import { useCart } from "../contexts/CartContext";
// import LogoutButton from "./LogoutButton";
// import ImageFile from "../images/afrogebeya.png";
// import "../styles/header.css";

// function Header({ hideExtras = false }) {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [suggestions, setSuggestions] = useState([]);
//   const [showUserMenu, setShowUserMenu] = useState(false);
//   const [activeIndex, setActiveIndex] = useState(-1);

//   const dropdownRef = useRef(null);
//   const buttonRef = useRef(null);
//   const hideTimerRef = useRef(null);
//   const searchWrapperRef = useRef(null);

//   const { auth, isAuthenticated } = useAuth();
//   const { cartCount } = useCart();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const displayName = auth?.firstName ?? "User";

//   const hideExtrasOnPath =
//     location.pathname.startsWith("/seller") ||
//     location.pathname.startsWith("/admin");

//   /* ---------------- SEARCH SUGGESTIONS ---------------- */

//   const fetchSuggestions = useCallback(
//     debounce(async (value) => {
//       if (!value.trim()) {
//         setSuggestions([]);
//         return;
//       }

//       try {
//         const res = await fetch(
//           `${process.env.REACT_APP_PRODUCT_SERVICE_URL}/products/search/suggestions?q=${value}`,
//         );

//         if (res.ok) {
//           const data = await res.json();
//           setSuggestions(data);
//         }
//       } catch (err) {
//         console.error("Suggestion error:", err);
//       }
//     }, 300),
//     [],
//   );

//   useEffect(() => {
//     fetchSuggestions(searchTerm);
//   }, [searchTerm, fetchSuggestions]);

//   /* ---------------- CLOSE SUGGESTIONS ON OUTSIDE CLICK ---------------- */

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (
//         searchWrapperRef.current &&
//         !searchWrapperRef.current.contains(e.target)
//       ) {
//         setSuggestions([]);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   /* ---------------- FIX CONTENT OFFSET ---------------- */

//   useLayoutEffect(() => {
//     const header = document.querySelector(".navbar-custom");
//     const main = document.querySelector("#main-content");

//     if (header && main) {
//       main.style.paddingTop = `${header.offsetHeight}px`;
//     }
//   }, []);

//   /* ---------------- SEARCH SUBMIT ---------------- */

//   const handleSearch = (e) => {
//     e.preventDefault();

//     if (activeIndex >= 0) {
//       navigate(`/products/${suggestions[activeIndex].id}`);
//     } else {
//       navigate(`/search?q=${searchTerm}`);
//     }

//     setSuggestions([]);
//   };

//   /* ---------------- KEYBOARD NAVIGATION ---------------- */

//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;

//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIndex((prev) => (prev + 1) % suggestions.length);
//     }

//     if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIndex((prev) => (prev <= 0 ? suggestions.length - 1 : prev - 1));
//     }

//     if (e.key === "Enter" && activeIndex >= 0) {
//       navigate(`/products/${suggestions[activeIndex].id}`);
//       setSuggestions([]);
//     }

//     if (e.key === "Escape") {
//       setSuggestions([]);
//     }
//   };

//   /* ---------------- USER MENU ---------------- */

//   const closeMenu = () => {
//     clearTimeout(hideTimerRef.current);
//     setShowUserMenu(false);
//   };

//   const startAutoClose = () => {
//     clearTimeout(hideTimerRef.current);
//     hideTimerRef.current = setTimeout(closeMenu, 3000);
//   };

//   /* ---------------- UI ---------------- */

//   return (
//     <nav className="navbar navbar-dark navbar-custom fixed-top shadow-sm px-3">
//       <div className="container-fluid header-container">
//         {/* LOGO */}
//         <Link
//           to="/"
//           className="navbar-brand d-flex flex-column flex-sm-row align-items-center gap-1 gap-sm-2"
//         >
//           <img
//             src={ImageFile}
//             alt="Afrogebeya Technology"
//             className="img-fluid"
//             style={{ maxHeight: "38px" }}
//           />
//           <strong className="d-none d-sm-inline">Afrogebeya</strong>
//         </Link>

//         {/* SEARCH */}
//         {!hideExtras && !hideExtrasOnPath && (
//           <div ref={searchWrapperRef} className="search-wrapper">
//             <form onSubmit={handleSearch} className="search-form">
//               <input
//                 type="search"
//                 placeholder="Search products..."
//                 value={searchTerm}
//                 autoComplete="off"
//                 className="search-input"
//                 onChange={(e) => {
//                   setSearchTerm(e.target.value);
//                   setActiveIndex(-1);
//                 }}
//                 onKeyDown={handleKeyDown}
//               />

//               <button className="search-btn">
//                 <i className="bi bi-search"></i>
//               </button>
//             </form>

//             {suggestions.length > 0 && (
//               <div className="suggestion-dropdown">
//                 {suggestions.map((item, index) => (
//                   <div
//                     key={item.id}
//                     className={`suggestion-item ${
//                       index === activeIndex ? "active" : ""
//                     }`}
//                     onClick={() => {
//                       navigate(`/products/${item.id}`);
//                       setSuggestions([]);
//                     }}
//                   >
//                     <div className="fw-semibold">{item.productName}</div>
//                     <div className="small text-muted">{item.price} ETB</div>
//                   </div>
//                 ))}

//                 <div
//                   className="suggestion-view-all"
//                   onClick={() => {
//                     navigate(`/search?q=${searchTerm}`);
//                     setSuggestions([]);
//                   }}
//                 >
//                   View all results →
//                 </div>
//               </div>
//             )}
//           </div>
//         )}

//         {/* RIGHT ACTIONS */}
//         {!hideExtras && (
//           <div className="header-actions">
//             {/* CART */}
//             <Link to="/cart" className="cart-btn">
//               <i className="bi bi-cart"></i>
//               {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
//             </Link>

//             {/* AUTH */}
//             {isAuthenticated ? (
//               <div className="user-menu-wrapper">
//                 <button
//                   ref={buttonRef}
//                   className="user-btn"
//                   onClick={() => {
//                     setShowUserMenu((v) => !v);
//                     startAutoClose();
//                   }}
//                 >
//                   <i className="bi bi-person-circle"></i> {displayName}
//                 </button>

//                 <div
//                   ref={dropdownRef}
//                   className={`user-dropdown ${showUserMenu ? "open" : ""}`}
//                   onMouseEnter={() => clearTimeout(hideTimerRef.current)}
//                   onMouseLeave={startAutoClose}
//                 >
//                   <Link
//                     to="buyer/profile"
//                     className="dropdown-item d-flex gap-2 p-2"
//                     onClick={closeMenu}
//                   >
//                     <i className="bi bi-person-circle"></i> Profile
//                   </Link>

//                   <Link
//                     to="buyer/settings"
//                     className="dropdown-item d-flex gap-2 p-2"
//                     onClick={closeMenu}
//                   >
//                     <i className="bi bi-gear"></i> Settings
//                   </Link>
//                   <hr />
//                   <LogoutButton closeMenu={closeMenu} />
//                 </div>
//               </div>
//             ) : (
//               <>
//                 <Link to="/login" className="auth-btn">
//                   Login
//                 </Link>

//                 <Link to="https://seller.afrogebeya.com" className="auth-btn">
//                   Sell on Afro Gebeya
//                 </Link>
//               </>
//             )}
//           </div>
//         )}
//       </div>
//     </nav>
//   );
// }

// export default Header;

import React, {
  useState,
  useLayoutEffect,
  useRef,
  useEffect,
  useCallback,
} from "react";
import debounce from "lodash/debounce";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useCart } from "../contexts/CartContext";
import LogoutButton from "./LogoutButton";
import ImageFile from "../images/afrogebeya.png";
import "../styles/header.css";

const PRODUCT_API = process.env.REACT_APP_PRODUCT_SERVICE_URL;
const IMAGE_BASE = "https://afrogebeya.com/uploads/products";
const PLACEHOLDER = "https://via.placeholder.com/40x40?text=+";

const resolveThumb = (url) =>
  url ? `${IMAGE_BASE}/${url.replace(/\\/g, "/")}` : PLACEHOLDER;

const formatPrice = (value, currency = "ETB") =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
  }).format(value || 0);

const createSlug = (name = "", id) =>
  `${name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")}-${id}`;

/* ─────────────────────────────────────────
   Main component
───────────────────────────────────────── */
function Header({ hideExtras = false, categories = [] }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const searchWrapperRef = useRef(null);
  const userMenuRef = useRef(null);
  const hideTimerRef = useRef(null);

  const { auth, isAuthenticated } = useAuth();
  const { cartCount } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const displayName = auth?.firstName ?? "User";
  const userInitials = (auth?.firstName?.[0] ?? "U").toUpperCase();
  const userRole = auth?.roles?.includes("SELLER")
    ? "Seller Account"
    : "Buyer Account";

  const hideExtrasOnPath =
    location.pathname.startsWith("/seller") ||
    location.pathname.startsWith("/admin");

  const shouldHide = hideExtras || hideExtrasOnPath;

  /* ── Suggestions fetch ── */
  const fetchSuggestions = useCallback(
    debounce(async (value) => {
      if (!value.trim()) {
        setSuggestions([]);
        return;
      }
      try {
        const res = await fetch(
          `${PRODUCT_API}/products/search/suggestions?q=${encodeURIComponent(value)}`,
        );
        if (res.ok) setSuggestions(await res.json());
      } catch {
        /* fail silently */
      }
    }, 300),
    [],
  );

  useEffect(() => {
    fetchSuggestions(searchTerm);
  }, [searchTerm, fetchSuggestions]);

  /* ── Close suggestions on outside click ── */
  useEffect(() => {
    const handler = (e) => {
      if (
        searchWrapperRef.current &&
        !searchWrapperRef.current.contains(e.target)
      ) {
        setSuggestions([]);
      }
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setShowUserMenu(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  /* ── Lock body scroll when drawer is open ── */
  useEffect(() => {
    document.body.style.overflow = drawerOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [drawerOpen]);

  /* ── Offset main content below fixed header ── */
  useLayoutEffect(() => {
    const header = document.querySelector(".hd-root");
    const main = document.querySelector("#main-content");
    if (header && main) {
      main.style.paddingTop = `${header.offsetHeight}px`;
    }
  }, [location.pathname]);

  /* ── Search submit ── */
  const handleSearch = (e) => {
    e.preventDefault();
    if (activeIndex >= 0 && suggestions[activeIndex]) {
      const s = suggestions[activeIndex];
      navigate(`/products/${createSlug(s.productName, s.id)}`);
    } else if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
    }
    setSuggestions([]);
    setDrawerOpen(false);
  };

  /* ── Keyboard navigation in suggestions ── */
  const handleKeyDown = (e) => {
    if (!suggestions.length) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((i) => (i + 1) % suggestions.length);
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((i) => (i <= 0 ? suggestions.length - 1 : i - 1));
    }
    if (e.key === "Enter" && activeIndex >= 0) {
      const s = suggestions[activeIndex];
      navigate(`/products/${createSlug(s.productName, s.id)}`);
      setSuggestions([]);
    }
    if (e.key === "Escape") setSuggestions([]);
  };

  /* ── User menu auto-close ── */
  const startAutoClose = () => {
    clearTimeout(hideTimerRef.current);
    hideTimerRef.current = setTimeout(() => setShowUserMenu(false), 3000);
  };

  const handleSuggestionClick = (item) => {
    navigate(`/products/${createSlug(item.productName, item.id)}`);
    setSuggestions([]);
    setSearchTerm("");
  };

  const closeDrawer = () => setDrawerOpen(false);

  /* ─────────────────────────────────────────
     Render
  ───────────────────────────────────────── */
  return (
    <>
      <header className="hd-root" role="banner">
        {/* ── Main row ── */}
        <div className="hd-main">
          {/* Hamburger — mobile only */}
          {!shouldHide && (
            <button
              className={`hd-hamburger${drawerOpen ? " hd-hamburger--open" : ""}`}
              aria-label={drawerOpen ? "Close menu" : "Open menu"}
              aria-expanded={drawerOpen}
              onClick={() => setDrawerOpen((v) => !v)}
            >
              <span className="hd-hamburger__line" />
              <span className="hd-hamburger__line" />
              <span className="hd-hamburger__line" />
            </button>
          )}

          {/* Logo */}
          <Link to="/" className="hd-logo" aria-label="Afrogebeya home">
            <img src={ImageFile} alt="" className="hd-logo__img" />
            <span className="hd-logo__name">
              Afro<span>gebeya</span>
            </span>
          </Link>

          {/* Search — desktop */}
          {!shouldHide && (
            <div ref={searchWrapperRef} className="hd-search">
              <form
                onSubmit={handleSearch}
                className="hd-search__form"
                role="search"
              >
                <input
                  type="search"
                  className="hd-search__input"
                  placeholder="Search products, brands, categories…"
                  value={searchTerm}
                  autoComplete="off"
                  aria-label="Search"
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setActiveIndex(-1);
                  }}
                  onKeyDown={handleKeyDown}
                />
                <button
                  type="submit"
                  className="hd-search__btn"
                  aria-label="Submit search"
                >
                  <i className="bi bi-search" />
                </button>
              </form>

              {/* Suggestions */}
              {suggestions.length > 0 && (
                <div
                  className="hd-suggestions"
                  role="listbox"
                  aria-label="Search suggestions"
                >
                  {suggestions.slice(0, 6).map((item, i) => (
                    <div
                      key={item.id}
                      role="option"
                      aria-selected={i === activeIndex}
                      className={`hd-suggestion${i === activeIndex ? " hd-suggestion--active" : ""}`}
                      onClick={() => handleSuggestionClick(item)}
                    >
                      <img
                        src={resolveThumb(item.mainImageUrl)}
                        alt=""
                        className="hd-suggestion__img"
                        onError={(e) => {
                          e.target.src = PLACEHOLDER;
                        }}
                      />
                      <span className="hd-suggestion__name">
                        {item.productName}
                      </span>
                      <span className="hd-suggestion__price">
                        {formatPrice(item.price, item.currency)}
                      </span>
                    </div>
                  ))}
                  <div
                    className="hd-suggestions__footer"
                    role="option"
                    onClick={() => {
                      navigate(`/search?q=${encodeURIComponent(searchTerm)}`);
                      setSuggestions([]);
                    }}
                  >
                    See all results for "{searchTerm}" →
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Right actions */}
          {!hideExtras && (
            <div className="hd-actions">
              {/* Cart */}
              <Link
                to="/cart"
                className="hd-cart"
                aria-label={`Cart, ${cartCount} items`}
              >
                <i className="bi bi-cart" />
                {cartCount > 0 && (
                  <span className="hd-cart__badge" aria-hidden="true">
                    {cartCount > 99 ? "99+" : cartCount}
                  </span>
                )}
              </Link>

              {isAuthenticated ? (
                /* User menu */
                <div
                  ref={userMenuRef}
                  className="hd-user"
                  onMouseEnter={() => clearTimeout(hideTimerRef.current)}
                  onMouseLeave={startAutoClose}
                >
                  <button
                    className="hd-user__btn"
                    aria-expanded={showUserMenu}
                    aria-haspopup="true"
                    onClick={() => {
                      setShowUserMenu((v) => !v);
                      startAutoClose();
                    }}
                  >
                    <div className="hd-user__avatar" aria-hidden="true">
                      {userInitials}
                    </div>
                    <span className="hd-user__name">{displayName}</span>
                    <i
                      className="bi bi-chevron-down hd-user__chevron"
                      aria-hidden="true"
                    />
                  </button>

                  <div
                    className={`hd-user__dropdown${showUserMenu ? " hd-user__dropdown--open" : ""}`}
                    role="menu"
                  >
                    <div className="hd-dropdown__header">
                      <div className="hd-dropdown__header-name">
                        {displayName}
                      </div>
                      <div className="hd-dropdown__header-role">{userRole}</div>
                    </div>

                    <Link
                      to="/buyer/profile"
                      className="hd-dropdown__item"
                      role="menuitem"
                      onClick={() => setShowUserMenu(false)}
                    >
                      <i className="bi bi-person" /> My Profile
                    </Link>
                    <Link
                      to="/buyer/orders"
                      className="hd-dropdown__item"
                      role="menuitem"
                      onClick={() => setShowUserMenu(false)}
                    >
                      <i className="bi bi-box-seam" /> My Orders
                    </Link>
                    <Link
                      to="/buyer/wishlist"
                      className="hd-dropdown__item"
                      role="menuitem"
                      onClick={() => setShowUserMenu(false)}
                    >
                      <i className="bi bi-heart" /> Wishlist
                    </Link>
                    <Link
                      to="/buyer/settings"
                      className="hd-dropdown__item"
                      role="menuitem"
                      onClick={() => setShowUserMenu(false)}
                    >
                      <i className="bi bi-gear" /> Settings
                    </Link>
                    <hr className="hd-dropdown__divider" />
                    <LogoutButton
                      closeMenu={() => setShowUserMenu(false)}
                      className="hd-dropdown__item hd-dropdown__item--danger"
                    />
                  </div>
                </div>
              ) : (
                /* Auth links */
                <>
                  <Link to="/login" className="hd-auth hd-auth--login">
                    Login
                  </Link>
                  <a
                    href="https://seller.afrogebeya.com"
                    className="hd-sell"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sell<span className="hd-sell__long"> on Afrogebeya</span>
                  </a>
                </>
              )}
            </div>
          )}
        </div>

        {/* ── Category nav bar — desktop ── */}
        {!shouldHide && (
          <nav className="hd-nav" aria-label="Product categories">
            <div className="hd-nav__inner">
              {/* <Link
                to="/products/buyers"
                className={`hd-nav__link${location.pathname === "/products/buyers" ? " hd-nav__link--active" : ""}`}
              >
                All Products
              </Link> */}
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className={`hd-nav__link${location.pathname === `/category/${cat.id}` ? " hd-nav__link--active" : ""}`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </nav>
        )}
      </header>

      {/* ── Mobile drawer overlay ── */}
      {!shouldHide && (
        <>
          <div
            className={`hd-overlay${drawerOpen ? " hd-overlay--open" : ""}`}
            aria-hidden="true"
            onClick={closeDrawer}
          />

          <nav
            className={`hd-drawer${drawerOpen ? " hd-drawer--open" : ""}`}
            aria-label="Mobile navigation"
            aria-hidden={!drawerOpen}
          >
            {/* Drawer header */}
            <div className="hd-drawer__head">
              <Link to="/" className="hd-logo" onClick={closeDrawer}>
                <img src={ImageFile} alt="" className="hd-logo__img" />
                <span className="hd-logo__name">
                  Afro<span>gebeya</span>
                </span>
              </Link>
              <button
                className="hd-drawer__close"
                onClick={closeDrawer}
                aria-label="Close menu"
              >
                <i className="bi bi-x-lg" />
              </button>
            </div>

            {/* Categories */}
            {categories.length > 0 && (
              <>
                <div className="hd-drawer__section-label">Categories</div>
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.id}`}
                    className="hd-drawer__link"
                    onClick={closeDrawer}
                  >
                    <i className="bi bi-grid" />
                    {cat.name}
                  </Link>
                ))}
              </>
            )}

            {/* Account links */}
            {isAuthenticated ? (
              <>
                <hr className="hd-drawer__divider" />
                <div className="hd-drawer__section-label">Account</div>
                <Link
                  to="/buyer/profile"
                  className="hd-drawer__link"
                  onClick={closeDrawer}
                >
                  <i className="bi bi-person" /> My Profile
                </Link>
                <Link
                  to="/buyer/orders"
                  className="hd-drawer__link"
                  onClick={closeDrawer}
                >
                  <i className="bi bi-box-seam" /> My Orders
                </Link>
                <Link
                  to="/buyer/wishlist"
                  className="hd-drawer__link"
                  onClick={closeDrawer}
                >
                  <i className="bi bi-heart" /> Wishlist
                </Link>
                <Link
                  to="/cart"
                  className="hd-drawer__link"
                  onClick={closeDrawer}
                >
                  <i className="bi bi-bag" />
                  Cart {cartCount > 0 && `(${cartCount})`}
                </Link>
                <hr className="hd-drawer__divider" />
                <LogoutButton
                  closeMenu={closeDrawer}
                  className="hd-drawer__link"
                />
              </>
            ) : (
              <div className="hd-drawer__footer">
                <Link
                  to="/login"
                  className="hd-drawer__auth-btn hd-drawer__auth-btn--login"
                  onClick={closeDrawer}
                >
                  Login
                </Link>
                <a
                  href="https://seller.afrogebeya.com"
                  className="hd-drawer__auth-btn hd-drawer__auth-btn--sell"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sell on Afrogebeya
                </a>
              </div>
            )}
          </nav>
        </>
      )}
    </>
  );
}

export default Header;
